var exports = {
  "k": "xcc377c0b--03a5e3--container",
  "i": "xcc377c0b--03a5e3--wrapper",
};

module.exports = exports;
